import React from 'react';
import RetinaImage from 'react-retina-image'
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faLinkedinIn, faGithub, faMediumM, faNpm, faSlideshare } from '@fortawesome/free-brands-svg-icons'

import Contacts from '../Contacts';

const FAIcon = styled(FontAwesomeIcon)`
    font-size: 1.5rem;
`

const LeftSection = styled.header`
  width: 100%;
  padding: 1.75rem 1.75rem 0rem;

  @media (min-width: 760px) {
    padding: 3.15rem 3.5rem 1.4rem;
    padding-bottom: 0;
  }

  @media (min-width: 1024px) {
    background-color: #fbfbfb;
    padding: 3.15rem 3.5rem 1.4rem;
    width: 30%;
    height: 100vh;
    text-align: right;
  }

  @media (min-width: 1200px) {
    .o-section__header {
      padding: 4.375rem 5.25rem 1.6625rem;
    }
  }
`

const SectionContent = styled.div`
  @media (min-width: 1024px) {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

const AvatarContainer = styled.div`
  text-align: center;

  @media (min-width: 1024px) {
    top: -2vh;
    margin-top: -5.8rem;
    text-align: right;
    position: relative;
  }
`

const Avatar = styled(RetinaImage).attrs({
  checkIfRetinaImgExists: false,
})`
  border-radius: 50%;
  width: 11rem;
  height: 11rem;

  @media (min-width: 760px) {
    width: 14rem;
    height: 14rem;
  }
`

const RightSection = styled.div`
  padding: 1.75rem 1.75rem 0rem;
  background: #fff;

  @media (min-width: 760px) {
    padding: 3.15rem 3.5rem 1.4rem;
    padding-top: 1.75rem;
  }

  @media (min-width: 1024px) {
    width: 70%;
    height: 100vh;
  }

  @media (min-width: 1200px) {
    padding: 4.375rem 5.25rem 1.6625rem;
  }
`

const RightSectionTop = styled.div`
  margin-bottom: 1.75rem;

  @media (min-width: 1024px) {
    top: -2vh;
    position: relative;
  }
`

const RightSectionBottom = styled.div`
  text-align: center;

  @media (min-width: 760px) {
    text-align: left;
  }

  @media (min-width: 1024px) {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }
`

const socialsList = [
  {
      icon: faLinkedinIn,
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/micheledisalvatore',
  },
  {
    icon: faTwitter,
    name: 'Twitter',
    url: 'https://twitter.com/MikDiSal',
  },
  {
      icon: faGithub,
      name: 'GitHub',
      url: 'https://github.com/micheledisalvatore/',
  },
  {
      icon: faMediumM,
      name: 'Medium',
      url: 'https://medium.com/@michele.disalvatore',
  },
  {
      icon: faNpm,
      name: 'NPM',
      url: 'https://www.npmjs.com/micheledisalvatore',
  },
  {
      icon: faSlideshare,
      name: 'Slideshare',
      url: 'https://www.slideshare.net/micheledisalvatore',
  },
];

export const Header = ({ name, surname, jobTitle }) => (
  <section className="o-section o-section--header  t-section  t-section--header">
    <div className="c-header">

      <div className="o-section__header-bg  t-section__header"></div>
      <div className="o-section__content-bg  t-section__content"></div>

      <div className="o-container">
        <div className="o-section__container">

          <LeftSection>
            <SectionContent>
              <AvatarContainer>
                <Avatar src="assets/images/header/avatar.jpg" alt={`${name} ${surname} picture`} />
              </AvatarContainer>
            </SectionContent>
          </LeftSection>

          <RightSection>
            <SectionContent>
              <RightSectionTop>
                <div className="c-header__brand">
                  <div className="c-brand">
                    <h1 className="c-brand__title  t-title">
                      <span className="c-brand__sizer">
                        <span className="a-header  c-brand__first-word  t-title__first-word">{name}</span>
                        <span className="a-header  c-brand__second-word  t-title__second-word">{surname}</span>
                      </span>
                    </h1>
                    <h2 className="a-header  c-brand__sub-title  t-sub-title">
                      <span className="c-brand__sizer">{jobTitle}</span>
                    </h2>
                  </div>
                </div>
                <ul className="c-social-buttons">
                  {socialsList.map(social => (
                    <li className="a-header" key={social.name}>
                      <a href={social.url} target="_blank" rel="noopener noreferrer" className="c-social-button  t-social-button" name={`External link to Michele Di Salvatore ${social.name} account`}>
                        <FAIcon icon={social.icon} />
                      </a>
                    </li>
                  ))}
                </ul>
              </RightSectionTop>
              <RightSectionBottom>
                <hr className="a-header  c-header__contact-divider" />
                <Contacts />
              </RightSectionBottom>
            </SectionContent>
          </RightSection>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js